module.exports = __webpack_public_path__ + "0a0c25a73895c3260f9952cb844870fd.pdf";